// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","prescription-list__item":"PrescriptionList_prescription-list__item__S-gyd"};